module.exports = __webpack_public_path__ + "img/co2.ba4e7dd2.png";